/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { isEqual } from "lodash";

export const isEmptyObject = (obj) => !obj || Object.keys(obj).length === 0;
export const isEqualObject = (obj, otherObj) => isEqual(obj, otherObj);
export const removeEmptyFields = (obj) =>
  Object.keys(obj)
    .filter((k) => obj[k] != null && obj[k] !== "")
    .reduce(
      (newObj, k) => {
        if (typeof obj[k] === "object") {
          return Array.isArray(newObj)
            ? [...newObj, removeEmptyFields(obj[k])]
            : { ...newObj, [k]: removeEmptyFields(obj[k]) };
        } else {
          return Array.isArray(newObj)
            ? [...newObj, obj[k]]
            : { ...newObj, [k]: obj[k] };
        }
      },
      Array.isArray(obj) ? [] : {}
    );
